<template>
  <v-row v-if="isShowResult && myProfile.network_type !== 'silver'">
    <v-col cols="12" sm="12" md="12" class="pa-0 mt-2">
      <v-alert
        dense
        type="error"
        class="mb-2"
      >
        <span class="font-size-10">
          Status Peringkat Belanja <strong class="text-uppercase">{{ upgradeTo }}</strong> Anda akan berlaku mulai <strong>{{ nextDate | tanggal }}</strong>.
        </span>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
moment.locale('id')

export default {
  props: [ 'myProfile', 'networkType' ],
  data() {
    return {
      isShowResult: false,
      nextDate: null,
      upgradeTo: ''
    }
  },
  watch: {
    myProfile(val, oldVal) {
      const upgradeDate = new Date()
      if (val !== oldVal) {
        this.checkUpgradeLabel()
        this.checkAllowUpgradeDate(upgradeDate)
      }
    }
  },
  methods: {
    checkAllowUpgradeDate(dates) {
      const date2 = moment(dates).format('YYYY-MM-DD')
      const dateNext =  moment(date2, 'YYYY-MM-DD').add(1, "days")

      if (dates && this.myProfile.network_is_last_updated) {
        this.isShowResult = true
        this.nextDate = moment(dateNext).format('YYYY-MM-DD')
      } else {
        this.isShowResult = false
        this.nextDate = '-'
      }
    },

    checkUpgradeLabel() {
      switch (this.networkType) {
        case 'gold':
          this.upgradeTo = 'Gold Star'
          break;
        case 'silver':
          this.upgradeTo = 'Silver'
          break;
        case 'diamond':
          this.upgradeTo = 'Diamond'
          break;
            
        default:
          this.upgradeTo = ''
          break;
      }
    }
  },

  async mounted() {
    const upgradeDate = new Date()
    this.checkUpgradeLabel()
    this.checkAllowUpgradeDate(upgradeDate)
  },
}
</script>